// DS: i7.13
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const EditorBold: React.FC<Props> = props => {
  return (
    <IconWrap {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="currentColor"
      >
        <path
          fillRule="evenodd"
          d="M10.003 10h3.003c1 0 1-2 0-2h-3.003v2zm0 3v3h3.003c2.002 0 2.002-3 0-3h-3.003zm3.786 6H9.002A2 2 0 017 17V7a2 2 0 012.002-2h3.914c1.482 0 2.646.639 3.406 1.792a4.022 4.022 0 01.168 4.145 4.113 4.113 0 01-.512.737c1.079.576 1.88 1.693 2 2.899.116 1.151-.236 2.239-.99 3.066-.788.865-1.954 1.361-3.2 1.361z"
          clipRule="evenodd"
        ></path>
      </svg>
    </IconWrap>
  );
};
EditorBold.displayName = 'EditorBold';

export default EditorBold;
